import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import './settings.scss';
import TextAreaWithLabel from '../../../components/fields/TextInput/TextAreaWithLabel';
import { getDefaultCollage, loadPresetsCollage } from '../actions';

import { getResponseError } from '../../../utils/utils';
import { errorNotification } from '../../Notifications/notificationDecorator';
import Loader from '../../../components/base/Loader/Loader';
import { getSettingsData } from '../reducer';

export default function PresetsSettingsModal(props) {
  const { handleClose = () => {}, handleSave = () => {}, data = {} } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  const [xml, setXml] = useState(data.collage_settings || '');
  const [src, setSrc] = useState(null);
  const dispatch = useDispatch();
  const { loadingPresetCollage } = useSelector(getSettingsData);
  useEffect(() => {
    setSrc(null);
    if (xml) {
      dispatch(loadPresetsCollage(xml))
        .then(data => {
          setSrc(data);
        })
        .catch(response => errorNotification(formatMessage({ id: 'collage.create' }), getResponseError(response)));
    }
  }, [xml]);
  useEffect(() => {
    if (!data.collage_settings) {
      dispatch(getDefaultCollage())
        .then(data => {
          setXml(data);
        })
        .catch(response => errorNotification(formatMessage({ id: 'template.load' }), getResponseError(response)));
    }
  }, []);
  return (
    <Dialog
      className="presets-settings-modal"
      size="xl"
      open
      onClose={handleClose}
    >
      <DialogTitle header={formatMessage({ id: 'collage.settings.form' })} title={<Icons onClick={handleClose} customIcon icon="close" className="close" />} />
      <DialogContent>
        <Loader loading={loadingPresetCollage} />
        <div className="presets-settings-wrapper">
          <div className="xml-column">
            <TextAreaWithLabel
              textarea
              label={formatMessage({ id: 'collage.xml.file' })}
              inputProps={{
                value: xml,
                onChange: e => setXml(e.target.value),
              }}
            />
          </div>
          <div className="collage-image-column">
            <div className="f4">{formatMessage({ id: 'collage.settings' })}</div>
            <div className="mt-3">
              {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
              {src ? <img className="collage-image" src={URL.createObjectURL(src)} alt="collage-image" /> : <div className="no-collage">{formatMessage({ id: 'collage.dont.create' })}</div>}
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogFooter>
        <Button onClick={() => handleSave(xml)}>{formatMessage({ id: 'app.save' })}</Button>
        <Button variant="secondary" onClick={() => handleClose()}>{formatMessage({ id: 'app.close' })}</Button>
      </DialogFooter>
    </Dialog>
  );
}
